import "./dse.scss";
import { FigureExpander } from "./FigureExpander";

new FigureExpander({selector: ".prose figure:not([data-dse-no-expand])"});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const bootstrap: any;

const NAVBAR_HEADER_SELECTOR = "#navbar-header";
const SITE_DROPDOWN_SELECTOR = ".site-dropdown";
const SITE_DROPDOWN_TOGGLER_SELECTOR = ".site-dropdown-toggler";
const TOP_OFFSET_CSS_VAR = "--top-offset";
const CARET_LEFT_CSS_VAR = "--caret-left";
const BORDER_WIDTH = 1;

const navbarHeader = document.querySelector(NAVBAR_HEADER_SELECTOR) as HTMLElement;
const siteDropdown = document.querySelector(SITE_DROPDOWN_SELECTOR) as HTMLElement;
const siteDropdownToggler = document.querySelector(SITE_DROPDOWN_TOGGLER_SELECTOR) as HTMLElement;

const updateSiteDropdownPositions = () => {
  const navbarPosition = navbarHeader.getBoundingClientRect();
  const offset = Math.round(navbarPosition.bottom - navbarPosition.top);

  siteDropdown.style.setProperty(TOP_OFFSET_CSS_VAR, `${offset - BORDER_WIDTH}px`);

  const dropdownTogglerPosition = siteDropdownToggler.getBoundingClientRect();
  const middle = Math.round(dropdownTogglerPosition.left + dropdownTogglerPosition.width / 2);

  siteDropdown.style.setProperty(CARET_LEFT_CSS_VAR, `${middle}px`);
};

if (navbarHeader && siteDropdown && siteDropdownToggler) {
  window.addEventListener("load", () => {
    updateSiteDropdownPositions();
  });

  window.addEventListener("resize", () => {
    updateSiteDropdownPositions();
  });
}

if (document.getElementById("group-sites-offcanvas")) {
  // Only initialize the offcanvas if it exists
  initGroupSitesDropdown();
}

function initGroupSitesDropdown() {
  const dismiss = document.getElementById("group-sites-offcanvas-dismiss");

  if (!dismiss) {
    throw new Error("Could not find group-sites-offcanvas-dismiss");
  }

  dismiss.addEventListener("click", () => {
    const oc = getBootstrapOffcanvas();
    oc.hide()
  });

  const open = document.getElementById("group-sites-offcanvas-open")

  if (!open) {
    throw new Error("Could not find group-sites-offcanvas-open");
  }

  open.addEventListener("click", () => {
    const el = getOffcanvasElement();
    const oc = bootstrap.Offcanvas.getOrCreateInstance(el);
    oc.show();
  })

  window.addEventListener("resize", () => {
    const el = getOffcanvasElement();
    const oc = bootstrap.Offcanvas.getInstance(el);

    if (!oc) {
      return;
    }

    oc.hide()
  });
}

function getOffcanvasElement() {
  const el = document.getElementById("group-sites-offcanvas");

  if (!el) {
    throw new Error("Could not find group-sites-offcanvas");
  }

  return el;
}

function getBootstrapOffcanvas() {
  const el = getOffcanvasElement();
  const oc = bootstrap.Offcanvas.getInstance(el);

  if (!oc) {
    throw new Error("Could not find group-sites-offcanvas instance");
  }

  return oc;
}
